import React from 'react';
import { Container } from "react-bootstrap"
import { Main } from "./screens"

function App() {
  return (
    <Container fluid className="mx-0 px-0 py-0 my-0">
      <Main />
    </Container>
  );
}

export default App;
